import axios from '../../../services/axios';

export function markAsRead(id) {
  return axios.post(`/api/activity-log/${id}/read`);
}

export function markAsUnread(id) {
  return axios.post(`/api/activity-log/${id}/unread`);
}
